import { render, staticRenderFns } from "./PlanejamentoSaude.vue?vue&type=template&id=07acb2aa&"
import script from "./PlanejamentoSaude.vue?vue&type=script&lang=js&"
export * from "./PlanejamentoSaude.vue?vue&type=script&lang=js&"
import style0 from "./PlanejamentoSaude.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports